import NotValidError from "./exception/NotValidError.ts";
import moment = require("moment");
import DateNotValidError from "./exception/DateNotValidError.ts";
import DateDuration from "./DateDuration.ts";
import DateInterval from "./DateInterval.ts";

export default class DateIntervalParser {

    date: string;
    durations: Array<DateDuration>;

    constructor() {
        this.date = '';
        this.durations = [];
    }

    /**
     * @param value
     */
    execute(value: string) {
        this.clear();
        this.valid(value);
        this.getParseDate(value);
        this.getParseDuration(value);

        return new DateInterval(this.durations, this.date);
    }

    clear() {
        this.date = '';
        this.durations = [];
    }

    /**
     * @param value
     */
    valid(value) {
        let patern = /(\d{4}[-\.]\d{2}[-\.]\d{2}|(now|NOW))((\s?[+-]P(\d*[Yy])?(\d*[Mm])?(\d*[Dd])?)+|)$/g;
        let matched = value.match(patern);

        if (null === matched) {
            throw new NotValidError(value);
        }
    }

    /**
     * @param value
     */
    getParseDate(value: string) {
        let dateStr = '';
        let patern = /[^\s]+/;
        let matched = value.match(patern);

        matched.forEach(m => {
            dateStr = m;
        });

        if (moment(dateStr).isValid()) {
            this.date = dateStr;
        } else if ('now' === dateStr.toLowerCase()) {
            return;
        } else {
            throw new DateNotValidError(dateStr);
        }
    }

    /**
     * @param value
     */
    getParseDuration(value: string) {
        let patern = /[+-]P(\d*[Yy])?(\d*[Mm])?(\d*[Dd])?/g;
        let matched = value.match(patern);

        if (null === matched) {
            return;
        }

        matched.forEach(m => {
            this.durations.push(new DateDuration(this.getSign(m), this.getInterval(m), this.getDateSign(m)));
        });
    }

    /**
     * @param value
     */
    getSign(value: string) {
        let paternSign = /[+-]/g;
        let matched = value.match(paternSign);
        return matched[0];
    }

    /**
     * @param value
     */
    getDateSign(value: string) {
        let paternDateSign = /[YyMmDd]/g;
        let matched = value.match(paternDateSign);
        return matched[0];
    }

    /**
     * @param value
     */
    getInterval(value: string) {
        let paternInterval = /\d+/g;
        let matched = value.match(paternInterval);
        return Number.parseInt(matched[0]);
    }

}





// WEBPACK FOOTER //
// ./src/Models/dateModels/DateIntervalParser.ts